<div class="pipeline-stage-card" [class.pipeline-stage-card--selected]="isSelected()"
  [class.pipeline-stage-card--disabled]="disabled()" [attr.role]="disabled() ? null : 'button'"
  [attr.tabindex]="disabled() ? null : 0" (click)="onCardClick()" (keydown.enter)="onCardClick()"
  (keydown.space)="onCardClick(); $event.preventDefault()" [style.border-width]="isSelected() ? '2px' : '1px'"
  [style.border-color]="isSelected() ? '#003399' : colorsTypes()[status()]">
  <div class="pipeline-stage-card__header" [style.border-bottom]="showStats() ? '1px solid #c3c7d4' : 'none'"
  [style.padding-bottom]="showStats() ? '16px' : '0'" [style.align-items]="showStats() ? 'flex-start' : 'center'">
    <div class="pipeline-stage-card__header-left">
      <icon-induxtry class="pipeline-stage-card__icon"
        [icon]="{ icon: 'database', background: stageColors()[title()] }"></icon-induxtry>
      <div class="pipeline-stage-card__titles">
        <span class="pipeline-stage-card__title">{{ title() }}</span>
        @if (subtitle()) {
        <span class="pipeline-stage-card__subtitle">{{ subtitle() }}</span>
        }
      </div>
    </div>
    <div class="pipeline-stage-card__header-right">
      <span class="pipeline-stage-card__status" [attr.data-status]="status()">
        <icon-induxtry class="pipeline-stage-card__status-icon" [icon]="{ icon: statusIconMap[status()] }"></icon-induxtry>
        <span class="pipeline-stage-card__status-label">{{ statusLabel() }}</span>
        @if (steps() && status() !== 'initializing') {
          {{ steps().progress }}/{{ steps().total }}
        }
      </span>
      @if (showFollowLogsButton() && status() === 'processing') {
      <button type="button" class="pipeline-stage-card__follow-logs" (click)="onFollowLogsClick($event)"
        aria-label="Acompanhar logs desta camada">Acompanhar logs</button>
      }
    </div>
  </div>

  @if(showStats()) {
    <div class="pipeline-stage-card__body">
      @if (isLoading()) {
      <div class="pipeline-stage-card__loading">Carregando...</div>
      } @else {
      <div class="pipeline-stage-card__stats">
        <div class="pipeline-stage-card__stat">
          <span class="pipeline-stage-card__stat-label">Total de registros</span>
          <span class="pipeline-stage-card__stat-value">{{
            formatNumber(dashboardData()?.total_records)
            }}</span>
        </div>
        <!-- <div class="pipeline-stage-card__stat">
          <span class="pipeline-stage-card__stat-label">Média geral</span>
          <span class="pipeline-stage-card__stat-value">{{
            formatNumber(dashboardData()?.average_mean)
            }}</span>
        </div> -->
        <!-- <div class="pipeline-stage-card__stat">
          <span class="pipeline-stage-card__stat-label">Desvio padrão médio</span>
          <span class="pipeline-stage-card__stat-value">{{
            formatNumber(dashboardData()?.average_std_deviation)
            }}</span>
        </div> -->
        <div class="pipeline-stage-card__stat">
          <span class="pipeline-stage-card__stat-label">Valores ausentes</span>
          <span class="pipeline-stage-card__stat-value">{{
            getValue(dashboardData()?.total_missing_values)
            }}</span>
        </div>
      </div>
      }
    </div>
  }
</div>